<h1 class="table-heading"><b>{{brandWithProducts.brandName}}</b></h1>
<div class="table-scroll-container">
<nz-table
[nzData]="brandWithProducts.products"
  [nzScroll]="{ x: '1000px', y: '400px' }"
  [nzBordered]="true"
>
    <thead>
        <tr>
            <th>Product Name</th>
            <th nzAlign="right" class="pr-50">Amount</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of brandWithProducts.products">
            <td>{{ item.productName }}</td>
            <td nzAlign="right" class="pr-50">{{ item.amount | currency }}</td>
        </tr>
    </tbody>
</nz-table>
</div>